export const CONFIG_CONTRACT_WHITELIST = "0x79de5F136C3dF01d80194dA8039aed8C4f9601c3";
export const CONFIG_CONTRACT_MINTER = "0xdFc49a51778eBbc8ED780BF662BC407bEf1d3F5c";
export const CONFIG_CONTRACT_NFT = "0x6E5c256710d0a8e63a991A5E63aea0462fD7513e";
//! ABI JSON